export enum RequestType {
    CompanyRequest = 1,
    IndividualRequest = 2
}
